import type { RouteRecordRaw } from 'vue-router';

export const assistantRoutes: RouteRecordRaw[] = [
  {
    name: 'assistant-index',
    component: () => import('../pages/index.vue'),
    path: '/assistant',
    meta: {
      middleware: 'auth',
    },
  },
];
